module.exports = __webpack_public_path__ + "ca.ea6532d7.svg";